import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function Kubernetes() {
  useEffect(() => {
    document.title = "Kubernetes Hosting | Managed Container Platform";
        sal();
      }, []);
  return (
    <>
      <Helmet>
        <title>Kubernetes Hosting | Managed Container Platform</title>
        <meta name="description" content="Deploy and manage containerized applications with Kubernetes hosting. Enjoy high availability, auto-scaling, and expert DevOps support." />
        <meta name="keywords" content="AWS Kubernetes, Managed Kubernetes, Kubernetes Cloud, Kubernetes" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/kubernetes`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/kubernetes`} />
        <meta property="og:title" content="Best & Trusted Managed Kubernetes Services" />
        <meta property="og:description" content="Get best-in-class kubernetes services with Infinitive Host. Avail the benefits of high scalability, multi-cloud services, and enterprise-level security solutions." />
      </Helmet>
      <section className="banner-bg bg-dark control-panel-banner slash-banner-part">
        <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-xl-6">
                  <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Hosting That Truly Works
                  </span>
                  <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Let’s Just Talk About Growth With Kubernetes.
                  </h1>
                  <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      Let’s be genuine-managing cloud stuff is a lot. Crashes, errors, downtime... all a mess. Now think about waking up, inspecting your dashboard, and it really works. Just you, growing big. Our Kubernetes? Silently running things in the backend while you chase what really matters-success, vision.</p>
                  <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <Link to="/contact-us" className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                          <span className="btn-arrow__text">
                              Get Started
                              <span className="btn-arrow__icon">
                                  <i className="fa-solid fa-arrow-right"></i>
                              </span>
                          </span>
                      </Link>
                  </div>
              </div>
              <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                  <img src="images/kubernetes-banner.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" />
              </div>
          </div>
        </div>
      </section>
      <div className="pt-60 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Next-Gen Vibes</small>
                    <h2 className="mb-4">Retro Apps? Go Advance with Our Kubernetes.</h2>
                    <p className="max-text-56 mb-0 fw-semibold">Your app’s doing the best-umm…but your hosting? Not enough. It’s the time to stop fixing things up and level up your setup. With our Kubernetes magic on Microsoft Azure, your applications run smoothly like butter.</p>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/upgrade-and-downgrade.webp" /></div>
                        <h6 className="mb-4">Upgrade & Downgrade</h6>
                        <p className="mb-0">Stuck in strict updates? Nah, not with us. With our Kubernetes hosting, you just install, switch, or roll back on your conditions-no hassle, no struggle. Just complete access and freedom.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/one-dashboard-no-issue.webp" /></div>
                        <h6 className="mb-4">One Dashboard, No Issue</h6>
                        <p className="mb-0">Tricky private and public cloud setups always get your head spinning? Simply get one intuitive interface to deploy, handle, and vibe with Kubernetes doing all the lifting.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/traffic-spike-no-issue.webp" /></div>
                        <h6 className="mb-4">Traffic Spike? No Issue</h6>
                        <p className="mb-0">High traffic? Your application shouldn't crash under peak pressure. With AWS Kubernetes, scaling is easy-even if it’s an unexpected growth, your containers stay ready to work.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/smart-load-smooth-flow.webp" /></div>
                        <h6 className="mb-4">Smart Load, Smooth Flow</h6>
                        <p className="mb-0">Running empty while all other parts are stuffed? Let Kubernetes completely balance the load, enhance assets, and make every single bit of your hosting count.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/no-more-broken-signals.webp" /></div>
                        <h6 className="mb-4">No More Broken Signals</h6>
                        <p className="mb-0">Ever think that your app is not syncing perfectly? Kubernetes hosting enables smooth container communication-just like a group chat that works just for you.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/teamwork-done-smoothly.webp" /></div>
                        <h6 className="mb-4">Teamwork Done Smoothly</h6>
                        <p className="mb-0">Challenging builds slow your team? With the help of AWS Kubernetes, container sharing across nodes is seamless-so teams collaborate smoothly and launch quickly. </p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/kubernetes-be-working-overtime.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-md-6 mobile-upper-space">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                K8s Grinding So You Don’t Have to.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Our Kubernetes Be Workin’ Overtime Just for You
                            </h3>
                                <ul>
                                    <li>Run your Kubernetes Cluster the way you want to-no seller lock-ins.</li>
                                    <li>Get support that’s all in with multi-tenant isolation.</li>
                                    <li>Ranging from app scaling to health checks, our K8s manages it all.</li>
                                    <li>Get ultra-fast container management across different nodes.</li>
                                    <li>Get microservice architecture for app development & deployment.</li>
                                    <li>Deploy different app versions, with automated load balancing.</li>
                                    <li>Get quicker app delivery & smarter asset utilization.</li>
                                    <li>Stay safe at every step with cutting-edge container safety.</li>
                                    <li>Run containerized apps on any OS or hardware with the same agility.</li>
                                </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Real-Time Best Friend.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Kubernetes Just Like Your Green Forest BFF (Reliable)
                            </h3>
                            
                                <ul>
                                    <li>Choose Kubernetes with full freedom-no vendor issue.</li>
                                    <li>Powered by expert recovery and solid isolation. You chill, we manage.</li>
                                    <li>Launch quickly with AI-based Kubernetes hosting. No wait, more wow.</li>
                                    <li>Always stay live across clusters. No more dips, only drip.</li>
                                    <li>Scalability, flexibility-we properly balance it all just like magic.</li>
                                    <li>Build, test, run-faster, smoother, superior.</li>
                                    <li>AWS, Azure, multi-cloud-your application moves just like a pro.</li>
                                    <li>Ranging from servers to clouds, your containers only flow.</li>
                                    <li>Top-notch cloud safety so your data sleeps freely.</li>                                        
                                </ul>
                          
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate  mobile-upper-space" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/kubernetes-just-like-bff.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Perks of K8s.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Solutions That Work Just For You</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Traffic Spike? Still Smooth.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/traffic-spike-no-issue.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Scaling quickly? Our Kubernetes config can manage it-just like it does perfectly for Google. Go smoothly, with zero collapse.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Switching & Slaying Clouds.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/level-up-cloud.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Want to move safely & flexibly? With our Managed Kubernetes, you can move your apps across clouds without any mess.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Unbeatable Security, 24/7.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/security-that-always.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Worried over app safety? We got you. With our Kubernetes container security in place, your tasks stay secure to scale.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-100 pb-80">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Your Site's Perfect Match.</span>
                                      <h4 className="mb-4">
                                          Web Dreams? Chill… We Host Them.
                                      </h4>
                                      <p className="mb-6">
                                        You & Managed Kubernetes = Ideal Match
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}
